import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuth } from "@clerk/clerk-react";
import { useInternalAccess } from "@/hooks/use-internal-access";

interface InternalRouteProps {
  children: React.ReactNode;
}

/**
 * Route wrapper that restricts access to internal users only
 * (users belonging to the Onsemble organization)
 */
export function InternalRoute({ children }: InternalRouteProps) {
  const [, setLocation] = useLocation();
  const { isSignedIn, isLoaded: authLoaded, getToken } = useAuth();
  const { isInternal, isLoaded: orgLoaded } = useInternalAccess();

  const isLoaded = authLoaded && orgLoaded;

  useEffect(() => {
    if (!isLoaded) return;

    // Redirect to login if not signed in
    if (!isSignedIn) {
      setLocation("/login");
      return;
    }

    // Redirect to home if not internal user
    if (!isInternal) {
      setLocation("/orders/new");
      return;
    }

    // Test token validity on route access
    getToken().catch(() => {
      setLocation("/login");
    });
  }, [isSignedIn, isInternal, isLoaded, setLocation, getToken]);

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  if (!isSignedIn || !isInternal) {
    return null;
  }

  return <>{children}</>;
}
